<template>
  <div id="app-launcher" />
</template>

<script>
import { AppLauncherJsUri, AppLauncherCssUri } from '@/config.js';
import { logger } from '@/utils/logger';
/* global ZynetAppLauncher */
export default {
  name: 'ZynetApps',
  data() {
    return {
      isCSSLoaded: false,
      isScriptLoaded: false
    }
  },
  mounted() {
    logger.log(this.isScriptLoaded);
    if (!this.isCSSLoaded) {
      this.loadCSS(AppLauncherCssUri);
      this.isCSSLoaded = true;
    }
    if (!this.isScriptLoaded) {
      this.loadScript(AppLauncherJsUri, () => {
        ZynetAppLauncher.init('#app-launcher', '');
        this.isScriptLoaded = true;
      });
    } else {
      ZynetAppLauncher.init('#app-launcher', '');
    }
  },
  methods: {
    loadCSS(href) {
      if (!document.head.querySelector(`link[href="${href}"]`)) {
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
      }
    },
    loadScript(src, callback) {
      if (!document.head.querySelector(`script[src="${src}"]`)) {
        let script = document.createElement('script');
        script.onload = callback;
        script.src = src;
        document.head.appendChild(script);
      } else {
        callback();
      }
    }
  }
}
</script>
